import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex p-jc-between p-ai-center" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "p-m-0" }, "Squad")
], -1)
const _hoisted_2 = { class: "p-grid" }
const _hoisted_3 = { class: "p-sm-6" }
const _hoisted_4 = { class: "p-fluid" }
const _hoisted_5 = { class: "p-field" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Nombre", -1)
const _hoisted_7 = { class: "p-sm-6" }
const _hoisted_8 = { class: "p-fluid" }
const _hoisted_9 = { class: "p-field" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "multiselect" }, "Cursos", -1)
const _hoisted_11 = { class: "p-inputgroup" }
const _hoisted_12 = { class: "p-grid p-mt-2" }
const _hoisted_13 = { class: "p-sm-6" }
const _hoisted_14 = { class: "p-sm-6 p-text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Panel = _resolveComponent("Panel")!

  return (!_ctx.isLoading)
    ? (_openBlock(), _createBlock(_component_Panel, { key: 0 }, {
        header: _withCtx(() => [
          _hoisted_1
        ]),
        default: _withCtx(() => [
          _createElementVNode("form", {
            onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.onSubmit($event)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _createVNode(_component_InputText, {
                      modelValue: _ctx.squad.name,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.squad.name = $event)),
                      id: "name",
                      placeholder: "Nombre",
                      required: ""
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_Dropdown, {
                        modelValue: _ctx.selectedProduct,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedProduct = $event)),
                        options: _ctx.allProducts,
                        optionLabel: "title",
                        placeholder: "Seleccionar",
                        required: "true"
                      }, null, 8, ["modelValue", "options"]),
                      _createVNode(_component_Button, {
                        icon: "pi pi-plus",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.onClickAddProduct(_ctx.selectedProduct)), ["prevent"]))
                      })
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode(_component_DataTable, {
              value: _ctx.products,
              dataKey: "_id",
              rowHover: true,
              showGridlines: "",
              responsiveLayout: "scroll",
              sortField: "title",
              sortOrder: "1"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  header: "Curso",
                  sortable: "",
                  field: "title"
                }),
                _createVNode(_component_Column, {
                  header: "",
                  style: {"width":"1%"}
                }, {
                  body: _withCtx(({ data }) => [
                    _createVNode(_component_Button, {
                      type: "button",
                      class: "p-button-icon-only p-button-rounded p-button-text",
                      icon: "pi pi-times",
                      onClick: _withModifiers(($event: any) => (_ctx.onClickRemoveProduct(data)), ["prevent"])
                    }, null, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_Button, {
                  type: "button",
                  class: "p-button-sm p-button-outlined",
                  icon: "pi pi-chevron-left",
                  label: "Volver",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.onClickBack()), ["prevent"]))
                }),
                (_ctx.squad._id)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      type: "button",
                      class: "p-button-sm p-button-link p-ml-2",
                      label: "Borrar",
                      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.onClickRemove()), ["prevent"]))
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_Button, {
                  type: "submit",
                  class: "p-button-sm",
                  icon: "pi pi-save",
                  label: "Guardar"
                })
              ])
            ])
          ], 32)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}